import type { FaireThemeEntity } from "../../entity_types/theme";

export const mother_s_day_giftable_self_care: FaireThemeEntity = {
  token: "mother-s-day-giftable-self-care",
  type: "theme",
  name: "Mother's Day Giftable Self-Care",
  description: "Curated self-care gifts create a seasonal sales spike and bundle well in-store -- pre-wrapped sets, counter displays, and last-minute gifting",
  teaser: "Fun, expressive impulse buys your beauty clients will love.",
  detail: "Your beauty lounge customers look for fun, expressive final touches. Built around the whimsical Chiffonier items in your cart -- Ramen Earrings, Lays Classic Chips Earrings, Sanrio Cuties.",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_p8t6db595n",
    "p_2mdef3w4yn",
    "p_yxadrfptd7",
    "p_pd4vqfvcsy",
    "p_ck8nx53z2t",
    "p_rpfg2nppf4",
    "p_kkcpvdghdq",
    "p_bw9q7fthrt",
    "p_cuugpg9ugs",
    "p_kthk92ruvt",
    "p_jekxx342fp",
    "p_v3kmnnuybg",
    "p_v45pjyjz46",
    "p_ks7hptwqug",
    "p_k4raz2z9sr",
    "p_ygvypm96z3",
    "p_q2jdea682m",
    "p_77gfe3u9by",
    "p_m35zmwq8r6",
    "p_jvxwdxj6m5",
    "p_f8tbvyj9wr",
    "p_2wrsmrvsmb",
    "p_mkhrqa2y4t",
    "p_ezg83hm7nu",
    "p_ef55jp2vzd",
    "p_exng7zy6ez",
    "p_rv535muhjj",
    "p_cpxbqc3arv",
    "p_c776d482m8",
    "p_w2aeqcrnaq",
    "p_dex5074i5p",
    "p_r222fabbmp",
    "p_mvnxwq4g7w",
    "p_pryvasyvgu",
    "p_p4vxc2uheu",
    "p_stv9bgn6cz",
    "p_mwgggrzbda",
    "p_ygenhkyj6p",
    "p_thd379vd7n",
    "p_ae1cdyg9",
    "p_pq94p3qcyx",
    "p_2a5pnq4qgj",
    "p_3j3nmerutb",
    "p_6tvbqzfwkn",
    "p_epvc5ba68j",
    "p_pwrznfgnnm",
    "p_nh9fhz48g4",
    "p_f4kbxz3cf4",
    "p_cfqkfcyyb3",
    "p_twucgt6bs6",
    "p_6dea7vcjq7",
    "p_ejtecbxlsz",
    "p_pjtt45u2hd",
    "p_8c8zg4ah9v",
    "p_8tcs78yja8",
    "p_5nqe9sf3py",
    "p_8a7zmvv9xz",
    "p_xgd59bd3xb",
    "p_424s399atk",
    "p_8b59t6hehq",
    "p_x8zn8z9mdw",
    "p_5lazl70x",
    "p_ps3ufaemx5",
    "p_9ebda6svmo",
    "p_xpyyzvehfy",
    "p_6rm9cthdfr",
    "p_juex45tn7n",
    "p_vwssret42y",
    "p_egnnzqszi6",
    "p_kk9u5fmpf9",
    "p_bryjg59c5k",
    "p_mxau2n7tg4",
    "p_u3fcq7r777",
    "p_74jb4dfpzt",
    "p_ze2mdxspej",
    "p_kjwfdfzbjt",
    "p_abkkzv5z3b",
    "p_ju2puhctrf",
    "p_vkva66tczr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
